import { SettingConst } from '../../types';

/**
 * Experiment to update product tiles to have price-frist with a bigger price size.
 * https:www.notion.so/faire/Price-first-product-tile-1292efb5c25a805083efd28ffdd4d85b
 */
export const PROMINENT_PRICE_FIRST_PRODUCT_TILES_250123 =
  'PROMINENT_PRICE_FIRST_PRODUCT_TILES_250123' as SettingConst<
    'PROMINENT_PRICE_FIRST_PRODUCT_TILES_250123',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
